<script setup>
  import { onMounted, ref, reactive,provide } from 'vue'
  import { maskName,exchangeRate } from '@/utils/index'
  import { useUserStore } from '@/stores/userStore';
  import { throttle } from "@/utils/throttle"; // 引入节流
  import { useBtnLoading } from "@/hooks/useBtnLoading"; // 引入按钮加载
  import axios from 'axios'
  import { useRouter } from 'vue-router';
  import { setshelvesFilterAPI } from '@/apis/pay'
  import { getCategoryFilterAPI,getTreeCategoryListAPI, setproductAddAPI, detailinfoAPI, setproductEditAPI ,getTemplateListAPI,addTemplateAPI,getProductTranslationAPI} from '@/apis/category'
  import { Delete, Plus } from '@element-plus/icons-vue'
  import {VueDraggable} from 'vue-draggable-plus'
  import EditorComponent from '@/components/WangEditor/index.vue';
  import { useI18n } from 'vue-i18n'
  // import {goUp} from '@/utils/index'
  const { t, locale } = useI18n();
  const userStore = useUserStore()
  let router = useRouter();
  const { isLoading, handleClick } = useBtnLoading();
  // const value = ref('初始内容');
  
  const from = reactive({
      name: {//商品名称
          en_us: '',
          zn: '',
          esp:'',
          pcp:'',
          ned:'',
          pl:'',
          de:'',
          pcf:'',
          ita:''
      },
      needIntlPostage:false,
      categoryId: null,
      price: 1,
      images: [],
      coverUrl: '',
      fileList: [],
      isVariables: false,//是否启用多规格
      skuData:{//单规格
          skuId:'',
          price:null,
          quantity:null
      },
      multiSkuData:[],//商品规格
     // [ { "name": { "zn": "颜色", "en_us": "颜色" }, "values": [ { "name": { "zn": "蓝色", "en_us": "蓝色" } }, { "name": { "zn": "zise", "en_us": "zise " } } ] }, { "name": { "zn": "尺码", "en_us": "尺码" }, "values": [ { "name": { "zn": "S", "en_us": "S" } }, { "name": { "zn": "M", "en_us": "M" } } ] } ],
      specifications: 
      {
        name: {
          zn:'',
          en_us:'',
          // esp:'',
          // pcp:'',
          // ned:'',
          // pl:'',
          // de:'',
          // pcf:'',
          // ita:''
          },
          values:[]
      },
      video:'',//视频
      description:{//商品详情
          en_us: '',
          zn: '',
          esp:'',
          pcp:'',
          ned:'',
          pl:'',
          de:'',
          pcf:'',
          ita:''
      },
      dataAll:[],
     
  })
  const standardForm=reactive({
      name:{
          zn:'',
          en_us:'',
          esp:'',
          pcp:'',
          ned:'',
          pl:'',
          de:'',
          pcf:'',
          ita:''
      }
  })
  const standardType=ref();
  //设置规格
  const standardFormRef = ref(null);
  const standardModel=ref(false);
  const handleClose=()=>{
      standardModel.value=false
      standardFormRef.value.resetFields();
  }
  const standard=(type,index)=>{
    skutranslate.value='zn'
    skutranslateLanguage.value='all'
    if(type==1){//表示规格
       console.log(from.multiSkuData.length) 
       if(from.multiSkuData.length==2){
        ElMessage({
                        message: t('setup590'),
                        type: 'warning',
                    })
        return
       }
       standardModel.value=true
        standardType.value=type//类型，是第一层还是第二层
        param.Tiers=type
        param.Subscript=index
    }else{
        standardModel.value=true
        standardType.value=type//类型，是第一层还是第二层
        param.Tiers=type
        param.Subscript=index
        if(type==2){
            param.typeModel=1
        }
    }
      
  }
  const param=reactive({
      Tiers:1,//层级
      Subscript:null,//下标
      typeModel:0,//1新增，2修改
      indexTiers:0,
      fixedHeaders: [{label:'sku',type:'input',key:'skuId'} ,{label:'价格',type:'num',key:'price'} ,{label:'数量',type:'num',key:'quantity'} ],
      tableData:[],
     
      newItem:{
          skuId:'',
          price:'',
          quantity:''
      },
      newData:[]
  })
  //动态下拉框值
  const headerFilterParams = ref({});
  //递归判断两个对象是否相等
  const deepEqual=(obj1, obj2)=> {
    // 基本类型比较
    if (obj1 === obj2) return true;
    
    // 检查null或非对象类型
    if (typeof obj1 !== 'object' || obj1 === null || 
        typeof obj2 !== 'object' || obj2 === null) {
        return false;
    }
    
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    
    // 检查key数量
    if (keys1.length !== keys2.length) return false;
    
    // 检查每个key
    for (const key of keys1) {
        if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
            return false;
        }
    }
    
    return true;
}
  const standardSubmit=()=>{
    // debugger;
    standardFormRef.value.validate(async (valid, fields) => {
        if(valid){
        if(param.Tiers==1){
            
            const data=standardForm.name
            from.specifications.name=JSON.parse(JSON.stringify(data));
            if(param.Subscript==null){
                console.log(1111)
                console.log(from.multiSkuData);
                const hasM = from.multiSkuData.some(item => item.name.zn === from.specifications.name.zn);
                if(!hasM){
                    from.multiSkuData.push(JSON.parse(JSON.stringify(from.specifications)))
                }else{
                    ElMessage({
                            message: t('setup601'),
                            type: 'warning',
                      
                    })
                }
            }else{
                console.log('修改父类')
                console.log(from.specifications.name)
                console.log(from.multiSkuData[param.Subscript].name)
                const hasM = from.multiSkuData.some(item => item.name.zn === from.specifications.name.zn);
                if(!hasM){
                   
                    from.multiSkuData[param.Subscript].name=JSON.parse(JSON.stringify(from.specifications.name))
                    param.Subscript=null
                    console.log(from.multiSkuData[param.Subscript])
                }else{
                    let ischeck=false
                    from.multiSkuData.forEach((item,i)=>{
                        if(item.name.zn === from.specifications.name.zn && i!=param.Subscript){
                            console.log('存在相同值',item)
                            ischeck=true
                        }
                    })
                    if(ischeck){
                        ElMessage({
                            message: t('setup601'),
                            type: 'warning',
                        })
                    }else{
                        let checkitem=from.multiSkuData[param.Subscript].name
                        console.log(checkitem, from.specifications.name)
                        console.log(deepEqual(checkitem, from.specifications.name))
                            if(deepEqual(checkitem, from.specifications.name)){
                                ElMessage({
                                    message: t('setup601'),
                                    type: 'warning',
                                })
                        }else{
                            console.log('修改相同zn值，但是其他值不同的数据')
                            from.multiSkuData[param.Subscript].name=JSON.parse(JSON.stringify(from.specifications.name))
                        }
                    }

                  
                }
            }
            console.log('from.multiSkuData',from.multiSkuData)
        }else if(param.Tiers==2){
            const SubsetData=standardForm.name
            console.log(SubsetData)
            if(param.typeModel==1){//新增
                console.log('新增子')
                const hasM = from.multiSkuData[param.Subscript].values.some(item => item.name.zn === SubsetData.zn);
                if(!hasM){
                    console.log(from.multiSkuData[param.Subscript].values)
                    from.multiSkuData[param.Subscript]?.values?.push(JSON.parse(JSON.stringify({name:SubsetData})))
                    console.log(from.multiSkuData)
                }else{
                  
                    ElMessage({
                            message: t('setup601'),
                            type: 'warning',
                      
                    })
                }
               
               
            }else{//修改
                console.log('修改子')
              
                const hasM = from.multiSkuData[param.indexTiers].values.some(item => item.name.zn === SubsetData.zn);
                if(!hasM){
                    from.multiSkuData[param.indexTiers].values[param.Subscript].name=JSON.parse(JSON.stringify(SubsetData))
                    console.log(from.multiSkuData)
                }else{
                    let ischeck=false
                    from.multiSkuData[param.indexTiers].values.forEach((item,i)=>{
                        if(item.name.zn === SubsetData.zn && i!=param.Subscript){
                            console.log('存在相同值',item)
                            ischeck=true
                        }
                    })
                    if(ischeck){
                        ElMessage({
                            message: t('setup601'),
                            type: 'warning',
                        })
                    }else{
                        let checkitem=from.multiSkuData[param.indexTiers].values[param.Subscript].name
                        console.log(checkitem)
                        if(deepEqual(checkitem, SubsetData)){
                                ElMessage({
                                    message: t('setup601'),
                                    type: 'warning',
                                })
                        }else{
                            console.log('修改相同zn值，但是其他值不同的数据')
                                from.multiSkuData[param.indexTiers].values[param.Subscript].name=JSON.parse(JSON.stringify(SubsetData))
                        }
                    }
                //    
                   
                }
               
            }
            
        }
        
        const result = from.multiSkuData.map(item => {
            const valueArray = [{ name: item.name.zn }]; // 添加属性名称
            item.values.forEach(value => {
                valueArray.push({ name: value.name.zn }); // 添加属性值
            });
            return { value: valueArray };
        });
        console.log(result)
        param.newData=JSON.parse(JSON.stringify(result))
        handleClose()
        }
    })
  }
  watch(() => param.newData, (newData) => {
        console.log('监听')
        newData.forEach((attr, index) => {
            if (attr?.value?.length > 0) {
                // console.log('赋值',attr.value);
                headerFilterParams.value[`model${index}`] = attr?.value[0]?.name; // 设置默认值
            }
        });
  }, { immediate: true });
  //删除
  const delskuData=(index)=>{
    skusDetailData.value=[]
    activePopoverIndex.value = null
      // 删除第二个对象
      //删除规格项
    //   skusDetailData.value.forEach(item=>{
    
    //     delete item['model'+index];
       
    //     Object.keys(item).forEach(element => {
    //         if(element.indexOf('model')!==-1){
    //         let i= item[ element]
    //             if(index< Number(element.split('model')[1])){
    //                 let keys='model'+(Number(element.split('model')[1])-1)
    //                 item[keys]=i
    //                 delete item[element] 
    //             }
    //         }
    //     });
    //   })
   
    //   console.log('skusDetailData.value', skusDetailData.value)

      from.multiSkuData.splice(index, 1);
      const result = from.multiSkuData.map(item => {
            const valueArray = [{ name: item.name.zn }]; // 添加属性名称
            item.values.forEach(value => {
                valueArray.push({ name: value.name.zn }); // 添加属性值
            });
            return { value: valueArray };
        });
        console.log(result)
        param.newData=JSON.parse(JSON.stringify(result))
       console.log(param.tableData) 
       getTemplateList()
       param.newItem.skuId=null;
       param.newItem.price=null;
       param.newItem.quantity=null;
  }
  
  //编辑父
  const editSkuData=(index)=>{
      const data=from.multiSkuData[index];
      console.log(data)
      param.Tiers=1
      param.Subscript=index
      standardForm.name=JSON.parse(JSON.stringify(data.name))
      standardModel.value=true
  
  
  }
  //拖拽子集
  const el = ref()
  const disabled = ref(false)
  function pause() {
    el.value?.pause()
  }
   
  function start() {
    el.value?.start()
  }
   
  const onStart = (e) => {
    console.log('start', e)
  }
   
  const onEnd = (e) => {
    console.log('onEnd', e)
  }
   
  const onUpdate = () => {
    console.log('update')
  }
  //双击修改事件
  const handleDoubleClick=(index,indexs)=>{
      console.log('双击修改时间')
      const data=from.multiSkuData[index].values[indexs];
      console.log(data)
      param.Tiers=2
      param.indexTiers=index;//一层的下标
      param.Subscript=indexs
      standardForm.name=JSON.parse(JSON.stringify(data.name))
      standardModel.value=true
      param.typeModel=2
  }
  const UploadImg=()=>{
      console.log('上传图片')
  }
  //删除规格值
  const delskuSubsetData=(index,subsetindex)=>{
    console.log(index,subsetindex)
      // 删除第二个对象
    //   console.log(from.multiSkuData[index].values[subsetindex])
    //sku值
      let all=[]
      if(skusDetailData.value){
        // const data=JSON.parse(JSON.stringify(skusDetailData.value))
            skusDetailData.value.map((item,indexs)=>{
            
            if(item[`model`+index.toString()] !== from.multiSkuData[index].values[subsetindex].name.zn){
                
                all.push(item)
            }
        })
        skusDetailData.value = all
      }
        
      
    //删除批量多规格
      let newALL=[]
      param.newData[index].value.forEach(newItem=>{
        console.log(newItem.name,from.multiSkuData[index].values[subsetindex].name.zn)
        if(newItem.name==from.multiSkuData[index].values[subsetindex].name.zn){
            console.log(newItem)
        }else{
            newALL.push(newItem)
        }
      })
      param.newData[index].value=newALL


      from.multiSkuData[index].values.splice(subsetindex, 1);
  }

  // 计算属性生成表格数据
  param.tableData=ref(computed(() => {
    // 获取所有的属性值数组
          const skuData=JSON.parse(JSON.stringify(from.multiSkuData))
          console.log('计算属性',1111111)
          console.log(skuData)
          const attributeValues = skuData.map(category => category?.values.map(value => value.name?.zn));
          console.log('获取所有的属性值数组',attributeValues)
          // 初始化组合数组
          let combinations = [[]];
  
          // 生成所有可能的组合
          attributeValues.forEach((values, index) => {
              console.log(values.length)
              if(values.length!=0){
              combinations = combinations.flatMap((combination) =>
              
                      values.map((value) =>{
                          console.log(value)
                          return [...combination, value]
                      }
                          // console.log([...combination, value])
                      
                      )
                  );
              }
          });    
          console.log('生成所有可能的组合',combinations)
          console.log('生成所有可能的组合',combinations.length)
          // 使用map方法将每个子数组转换为对象
              const processedData = combinations.map(item => {
                  const obj = {};
                  // if(item?.length>0){
                      item.forEach((value, index) => {
                      
                          obj[`model${index}`] = value;
                          
                      });
                  // }
                  return obj;
              });
              console.log('processedData',processedData)
              console.log('from.dataAll',from.dataAll)
              // 添加新属性到每个对象
              const updatedArray = processedData.map(item => ({
                  ...item,
                  skuId: '',
                  price: '',
                  quantity: 0
              }));
              // 1. 创建映射表：将 arr2 转换为 { "model0|model1": data } 格式
                const map = new Map();
                processedData.forEach(item => {
                const key = `${item.model0}|${item.model1}`; // 用分隔符组合唯一键
                map.set(key, item);
                });
                console.log('updatedArray',updatedArray)
                // 2. 合并数据
                const mergedArr = updatedArray.map(item => {
                    const key = `${item.model0}|${item.model1}`;
                    // 找到匹配的 arr2 数据
                    const matched = map.get(key);
                    // 合并对象（如果匹配到）
                    return matched 
                        ? { ...item, skuId: matched.skuId, price: matched.price, quantity: matched.quantity }
                        : item;
                });
                console.log('mergedArr1',mergedArr)

               
              if(updataDetail.value==false){//表示新增
                console.log('多规格值',mergedArr);
                console.log(from.dataAll)
                // 1. 遍历数组1
                    const result = mergedArr.map(item1 => {
                    // 2. 在数组2中查找model0相同的项
                    console.log(111)
                    const matchingItem = from.dataAll.find(item2 =>{
                        return (((item2.model0 === item1.model0) && !item1.model1) || (item2.model0 === item1.model0&&item2.model1 === item1.model1))
                        } 
                    );
                   console.log('matchingItem',matchingItem)
                    // 3. 如果找到匹配项，则合并值
                    if (matchingItem) {
                        console.log('匹配项',matchingItem)
                        return {
                        ...item1,  // 保留原有属性
                        skuId: matchingItem.skuId !== undefined ? matchingItem.skuId : item1.skuId,
                        price: matchingItem.price !== undefined ? matchingItem.price : item1.price,
                        quantity: matchingItem.quantity !== undefined ? matchingItem.quantity : item1.quantity
                        };
                    }
                    
                    // 4. 没有匹配项则返回原对象
                    console.log('没有匹配',item1)
                    return item1;
                    });
                   console.log(result)
                from.dataAll=result;
                return result;
              }else{
                   // 1. 创建唯一键集合
                    const keysSet = new Set();
                    skusDetailData.value.forEach(item => {
                        const key = `${item.model0}-${item.model1}`;
                        keysSet.add(key);
                    });
                    console.log('skusDetailData--',skusDetailData.value)
                    console.log('mergedArr',mergedArr)
                    console.log('页面值',from.dataAll)
                    console.log('sku值',skusDetailData.value)
                    // 2. 合并数组
                    const ArrayList = [...skusDetailData.value]; // 初始化结果为数组1的副本
                    mergedArr.forEach(item => {
                        const key = `${item.model0}-${item.model1}`;
                        if (!keysSet.has(key)) {
                            ArrayList.push(item); // 添加数组2中不重复的项
                        }
                    });
                   
                   console.log('sku值',skusDetailData.value)
                   console.log(ArrayList)
                    // 检查最后一条数据是否有model1
                    const lastItemHasModel1 = ArrayList.length > 0 && ArrayList[ArrayList.length - 1].hasOwnProperty('model1');

                    // 根据结果过滤数组
                    const filteredDataAll = lastItemHasModel1 
                    ? ArrayList.filter(item => item.hasOwnProperty('model1'))
                    :  ArrayList.filter(item => Boolean(item.model0));

                    console.log(filteredDataAll);
                    console.log(from.dataAll)
                    // 过滤条件：保留 model0 不为空字符串的对象
                    const filteredData =filteredDataAll;
                    console.log('修改后规格值',filteredData)
                console.log(from.dataAll)
                // 1. 遍历数组1
                    const result = filteredData.map(item1 => {
                    // 2. 在数组2中查找model0相同的项
                    console.log(111)
                    const matchingItem = from.dataAll.find(item2 =>{
                        return (((item2.model0 === item1.model0) && !item1.model1) || (item2.model0 === item1.model0&&item2.model1 === item1.model1))
                        } 
                    );
                   console.log('matchingItem',matchingItem)
                    // 3. 如果找到匹配项，则合并值
                    if (matchingItem) {
                        console.log('匹配项',matchingItem)
                        return {
                        ...item1,  // 保留原有属性
                        skuId: matchingItem.skuId !== undefined ? matchingItem.skuId : item1.skuId,
                        price: matchingItem.price !== undefined ? matchingItem.price : item1.price,
                        quantity: matchingItem.quantity !== undefined ? matchingItem.quantity : item1.quantity
                        };
                    }
                    
                    // 4. 没有匹配项则返回原对象
                    console.log('没有匹配',item1)
                    return item1;
                    });
                        console.log(result)
                        console.log('mergedArr-------',mergedArr)
                       let resultMergedArr=[]
                        mergedArr.forEach(arr=>{
                            console.log(arr)
                            if(arr?.model0 && arr?.model1){
                                result.forEach(resultItem=>{
                                    if(resultItem?.model0==arr?.model0 &&resultItem?.model1==arr?.model1){
                                        console.log('arr---',arr,resultItem)
                                        
                                        arr=resultItem;
                                        resultMergedArr.push(arr)
                                        console.log(arr)
                                    }
                                })
                            }else if(arr?.model0){
                                result.forEach(resultItem=>{
                                    if(resultItem?.model0==arr?.model0){
                                        arr=resultItem;
                                        resultMergedArr.push(arr)
                                    }
                                })
                            }else if(arr?.model1){
                                result.forEach(resultItem=>{
                                    if(resultItem?.model1==arr?.model1){
                                        arr=resultItem;
                                        resultMergedArr.push(arr)
                                    }
                                })
                            }
                        })
                        console.log(resultMergedArr)
                      
                   
                    from.dataAll=resultMergedArr;
                    return resultMergedArr;
     
               
              }
             
         
  }));


  // 使用 computed 计算属性来判断
  const allValuesHaveLength = computed(() => {
    return from.multiSkuData.some(item => item?.values?.length > 0);
  });
  //批量
  const setNewItem=()=>{
    const mergedObj = { ...headerFilterParams.value, ...param.newItem };
    let hasExactMatch = false; // 用于标记是否有完全匹配的对象
    let hasPartialMatch = false; // 用于标记是否有部分匹配的对象
  
    // 第一轮：检查是否有完全匹配的对象
    from.dataAll.forEach((item, index) => {
      let isMatch = true;
      for (const key in mergedObj) {
        if (key === 'skuId' || key === 'price' || key === 'quantity') continue;
        if (item[key] !== mergedObj[key]) {
          isMatch = false;
          break;
        }
      }
      if (isMatch) {
         console.log('检查是否有完全匹配的对象')
        if(mergedObj?.skuId !== null && mergedObj.skuId !== ""){
        item.skuId = `${mergedObj.skuId}-${index}`;
        }
        if(mergedObj?.price !== null && mergedObj.price !== ""){
        item.price = parseFloat(mergedObj.price);
        }
        if(mergedObj?.quantity !== null && mergedObj.quantity !== ""){
        item.quantity = parseFloat(mergedObj.quantity);
        }
        hasExactMatch = true;
      }
    });
  
    // 如果没有完全匹配，检查是否有部分匹配
    if (!hasExactMatch) {
      // 提取 updateObject 中所有以 "model" 开头的键
      const modelKeys = Object.keys(mergedObj).filter(key => key.startsWith("model"));
  
      // 尝试部分匹配：优先匹配第一个非空的 model 属性
      for (const key of modelKeys) {
        const targetValue = mergedObj[key];
        if (targetValue) {
            console.log('部分匹配')
          from.dataAll.forEach((item, index) => {
            if (item[key] === targetValue) {
                if(mergedObj?.skuId !== null && mergedObj.skuId !== ""){
                    item.skuId = `${mergedObj.skuId}-${index}`;
                }
                if(mergedObj?.price !== null && mergedObj.price !== ""){
                    item.price = parseFloat(mergedObj.price);
                }
                if(mergedObj?.quantity !== null && mergedObj.quantity !== ""){
                    item.quantity = parseFloat(mergedObj.quantity);
                }
              hasPartialMatch = true;
            }
          });
          // break; // 只处理第一个匹配的 model 属性
        }
      }
    }
  
    // 如果没有完全匹配也没有部分匹配，更新所有对象
    if (!hasExactMatch && !hasPartialMatch) {

      console.log('如果没有完全匹配')
      from.dataAll.forEach((item, index) => {
        console.log('如果没有完全匹配')
        if(mergedObj?.skuId !== null && mergedObj.skuId !== "" ){
       
            console.log('item.isEdit',item.isEdit)
            if(item.isEdit==true){
                console.log('不做处理')
            }else{
                item.skuId = `${mergedObj.skuId}-${index}`;
            }
       }
       if(mergedObj?.price !== null && mergedObj.price !== ""){
            item.price =parseFloat(mergedObj.price);
       }
       if(mergedObj?.quantity !== null && mergedObj.quantity !== ""){
            item.quantity = parseFloat(mergedObj.quantity);
       }
        
      });
    }
  }
  
  // const formError = ref({});
  const RemoveImg = ref([])
  const dialogImageUrl = ref('')
  const dialogVisible = ref(false)
  // 预览图片
  const handlePictureCardPreview = (uploadFile) => {
      dialogImageUrl.value = uploadFile
      dialogVisible.value = true
  }
  //删除
  const handleRemove = (uploadFile) => {
 
      RemoveImg.value.push(uploadFile)
      const index = from.images.findIndex(f => f=== uploadFile)
        if (index !== -1) {
            const newList = [...from.images]
            newList.splice(index, 1)
            from.images = newList
        }
  }
  
  const formRef = ref(null);
  //2. 准备规则对象
  const rules = {
      categoryId: [
          { required: true, message: t('setup36'), trigger: 'blur' }
      ],
        "name.en_us": [
        { required: true, message: t('setup508'), trigger: 'blur' }
        ],
        "name.zn": [
        { required: true, message: t('setup509'), trigger: 'blur' }
        ],
        
        "skuData.skuId": [
        { required: true, message: t('setup517'), trigger: 'blur' },
        ],
        "skuData.quantity": [
            { required: true, message:t('setup518'), trigger: 'blur' },

        ],
        "skuData.price": [
            { required: true, message: t('setup519'), trigger: 'blur' },

        ],
        // "description.en_us": [
        // { required: true, message: t('setup520'), trigger: 'blur' }
        // ],
        // "description.zn": [
        // { required: true, message: t('setup521'), trigger: 'blur' }
        // ],
        
     
        images: [
          { required: true, message: t('setup42'), trigger: 'blur' },
  
      ],
      skuId: [
        { required: true, message: t('setup598'), trigger: 'blur' }
      ],
      price: [
        { required: true, message: t('setup599'), trigger: 'blur' },
      ],
      quantity: [
        { required: true, message: t('setup600'), trigger: 'blur' },
      ]
  }
// 动态获取字段规则
const getFieldRules=(key) =>{
    return rules[key] || [];
  }
  const standardrules={
    "name.en_us": [
    { required: true, message: t('setup508'), trigger: 'blur' }
    ],
    "name.zn": [
    { required: true, message: t('setup509'), trigger: 'blur' }
    ],
  }

  const onSubmit = async () => {
      console.log(from)
      formRef.value.validate(async (valid, fields) => {
          if (valid) {
                if(from.isVariables==true){
                    if(from.dataAll.length==0){
                        ElMessage({
                            message: t('setup603'),
                            type: 'warning',
                        })
                        return;
                    }
                }
                // 检查两个描述字段是否都为空
               if((!from.description.en_us || !from.description.zn)&& !(!from.description.en_us && !from.description.zn) ) {
                    console.log(from.description.en_us)
                    console.log(from.description.zn)
                    ElMessage({
                        message: t('setup604'),
                        type: 'warning',
                    })
                    return;
                } 
              if (router.currentRoute.value.params.id) {
                console.log('修改')
                let variablesInfo='';
                  if(from.isVariables==false){//表示单规格
                      variablesInfo = from.skuData
                      from.multiSkuData=[]
                  }else{//多规格
                      variablesInfo= from.dataAll
                      variablesInfo.forEach((item, index) => {
                        item.price =parseFloat( item.price);
                        item.quantity = parseFloat(item.quantity);
                    });
                  }
                 let imagelist=[]
                 if(from.images.length>0){
                    const filteredData = from.fileList.filter(item => !item.url.startsWith('blob:http'));
                   console.log()
                    const mergedArray = filteredData.concat(from.images);
                   
                     // 遍历数据
                     mergedArray.forEach(item => {
                        if (typeof item === "object" && item !== null && "url" in item) {
                            // 如果元素是对象且包含 "url" 键
                            imagelist.push(item.url);
                        } else if (typeof item === "string") {
                            // 如果元素是字符串
                            imagelist.push(item);
                        }
                    });
                    console.log(imagelist)

                 }else{
                    console.log( from.fileList)
                    imagelist = from.fileList.map(item => item.url);
                   
                 }
                  console.log(imagelist)
                  console.log(from.categoryId.length)
                 
                 
                  let data = {
                      id: parseInt(router.currentRoute.value.params.id),
                      categoryId: from.categoryId,
                      needIntlPostage:from.needIntlPostage,
                      // inventory:from.inventory,
                      variables:from.multiSkuData.length>0 ?from.multiSkuData :'',//商品规格
                      video:from.video,//视频
                      name: from.name,
                      description: from.description,
                      // coverUrl: from.images[0],
                      images: imagelist,
                      isVariables:from.isVariables==false ? 2:1,
                      variablesInfo:variablesInfo,//规格信息
                  }
                  console.log('data',data)
                  const res = await setproductEditAPI(data)
                  if (res.code == 0) {
                      ElMessage({ type: 'success', message: t('setup23') })
                      router.push('/member/publish')
                  } else {
                      ElMessage({ type: 'error', message: res.message })
                  }
             
              } else {
                  let variablesInfo='';
                  if(from.isVariables==false){//表示单规格
                      variablesInfo = from.skuData
                  }else{//多规格
                      variablesInfo= from.dataAll
                        variablesInfo.forEach((item, index) => {
                            item.price =parseFloat( item.price);
                            item.quantity = parseFloat(item.quantity);
                        });
                  }
                  let data = {
                      // price: from.skuData.price,
                      categoryId: from.categoryId,
                      needIntlPostage:from.needIntlPostage,
                      // inventory:from.inventory,
                      variables:from.multiSkuData.length>0 ?from.multiSkuData :'',//商品规格
                      video:from.video,//视频
                      name: from.name,
                      description: from.description,
                      // coverUrl: from.images[0],
                      images: from.images,
                      isVariables:from.isVariables==false ? 2:1,
                      variablesInfo:variablesInfo,//规格信息
                  }
                  console.log('data',data)
                  const res = await setproductAddAPI(data)
                  if (res.code == 0) {
                      ElMessage({ type: 'success', message: t('setup23') })
                      router.push('/member/publish')
                  } else {
                      ElMessage({ type: 'error', message: res.message })
                  }
              }
  
          }else{
              console.log(fields)
            //   fields.categoryId
              // 提取所有 message 并循环弹出
            // Object.values(fields)
            // .flatMap(errorArray => errorArray.map(error => error.message))
            // .forEach(item =>
            //  ElMessage({ type: 'error', message:item })

            //   )}
            //   })
            }
        })
    }
  const handleSubmit = throttle(onSubmit, 5000);


//   const isEdit=ref(false);
const updataDetail=ref(false)
const skusDetailData=ref()
/**
 * 获取详情
 */
  const detail = async () => {
  
      const res = await detailinfoAPI({ id: router.currentRoute.value.params.id, userId: userStore.userInfo.id })
      if (res.code == 0) {
          console.log(res.data.data)
        //   isEdit.value=true
        //   from=res.data.data
        //   from.images=JSON.parse(res.data.data.images)
      
        //   from.images = JSON.parse(res.data.data.images);
          //
          // 数据处理
          updataDetail.value=true
          from.needIntlPostage=res.data.data?.needIntlPostage;
          res.data.data.names.forEach((item) => {
                if (from.name.hasOwnProperty(item.locale)) {
                    from.name[item.locale] = item.name;
                }
            });
            res.data.data.descriptions.forEach((item) => {
            if (from.description.hasOwnProperty(item.locale)) {
                    from.description[item.locale] = item.content;
            }
            });
            from.categoryId = res.data.data.categoryId;
            // from.fileList = res.data.data.images.map(item => (item ));
            from.images=res.data.data.images
            from.isVariables=res.data.data.isVariables==2? false:true
            if(res.data.data.isVariables==2){
                from.skuData=res.data.data.skus[0];
                from.skuData.isEdit=true
            }
           

            // param.newData = res.data.data.skus
            from.video = res.data.data.video
            console.log('详情',from.description)
            if(from.isVariables!=2){ 
                from.multiSkuData=res.data.data.variableAttr
                const result = from.multiSkuData.map(item => {
                    const valueArray = [{ name: item.name.zn }]; // 添加属性名称
                    item.values.forEach(value => {
                        valueArray.push({ name: value.name.zn }); // 添加属性值
                    });
                    return { value: valueArray };
                });
                param.newData=JSON.parse(JSON.stringify(result))
               
                skusDetailData.value=res.data.data.skus
                skusDetailData.value.map(item=>{
                    item.isEdit=true
                })
            }
      
        //  from.dataAll=res.data.data.skus
         console.log('param.dataAll',from.dataAll)
        
      } else {
          ElMessage({ type: 'error', message: res.message })
      }
  }
  
  
  // 上传前的检查
  const beforeUpload = (file) => {
    console.log(from.images.length)
      // 检查文件类型
      const isValidType = ['image/jpeg', 'image/png', 'image/gif'].includes(file.type)
      if (!isValidType) {
          ElMessage.error(t('number18'))
          return false
      }
  
      // 检查文件大小（小于10MB）
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
          ElMessage.error(t('number19'))
          return false
      }
      return true
  }
  //上传视频前的检查
  const videoBeforeUpload= (file) => {
     // 文件类型限制
     const isVideo = file.type === 'video/mp4' || file.type === 'video/webm' || file.type === 'video/ogg';
        // 文件大小限制（2MB）
        const isLt2M = file.size / 1024 / 1024 < 2;
        // 视频时长限制（1分钟）
        const maxDuration = 60;
  
        if (!isVideo) {
          ElMessage.error(t('setup510'));
          return false;
        }
  
        if (!isLt2M) {
          ElMessage.error(t('setup511'));
          return false;
        }
  
        return new Promise((resolve, reject) => {
          const video = document.createElement("video");
          video.preload = "metadata";
          video.src = URL.createObjectURL(file);
  
          video.onloadedmetadata = () => {
            const duration = video.duration;
            if (duration > maxDuration) {
              ElMessage.error(`${t('setup512')} ${maxDuration} ${t('setup513')}!`);
              reject();
            } else {
              resolve(true);
            }
          };
  
          video.onerror = () => {
            ElMessage.error(t('setup514'));
            reject();
          };
        });
  
   
  };
  //上传视频
  const uploadSuccess= async (options) => {
      try {
          // 1. 获取文件扩展名
          const fileExt = options.file.name.split('.').pop()
  
          // 2. 调用后端接口获取预签名URL
          const { data: presignedData } = await setshelvesFilterAPI({
              fileExtension: fileExt,
              bucketName: 'products-video'
          })
  
          // 3. 准备表单数据
          const formData = new FormData()
          // 添加后端返回的所有表单字段
          Object.entries(presignedData.formData).forEach(([key, value]) => {
              formData.append(key, value)
          })
          console.log(presignedData.formData)
          // 添加文件
          formData.append('file', options.file)
  
          // // 4. 执行上传
          const response = await axios.post(presignedData.url, formData, {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
          })
  
          // // 5. 上传成功
          if (response.status === 204) {
              console.log(response)
              ElMessage.success(t('number20'))
              // 构建文件访问URL
              const fileUrl = `${presignedData.url}${presignedData.formData.key}`
              // 可以在这里处理上传成功后的逻辑，比如将fileUrl保存到表单中
              from.video=fileUrl
              console.log(fileUrl)
          }
      } catch (error) {
          ElMessage.error(error.message)
          throw error
      }
  }
  //上传规格图片
  const variablesUpload = async (options,index,indexs) => {
      try {
          // 1. 获取文件扩展名
          const fileExt = options.file.name.split('.').pop()
  
          // 2. 调用后端接口获取预签名URL
          const { data: presignedData } = await setshelvesFilterAPI({
              fileExtension: fileExt,
              bucketName: 'product-variables'
          })
  
          // 3. 准备表单数据
          const formData = new FormData()
          // 添加后端返回的所有表单字段
          Object.entries(presignedData.formData).forEach(([key, value]) => {
              formData.append(key, value)
          })
          console.log(presignedData.formData)
          // 添加文件
          formData.append('file', options.file)
  
          // // 4. 执行上传
          const response = await axios.post(presignedData.url, formData, {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
          })
  
          // // 5. 上传成功
          if (response.status === 204) {
              console.log(response)
              ElMessage.success(t('number20'))
              // 构建文件访问URL
              const fileUrl = `${presignedData.url}${presignedData.formData.key}`
              console.log(fileUrl)
              // 可以在这里处理上传成功后的逻辑，比如将fileUrl保存到表单中
              // from.coverUrl = fileUrl
              from.multiSkuData[index].values[indexs].img=fileUrl
              console.log(index,indexs,fileUrl)
          }
      } catch (error) {
          ElMessage.error( error.message)
          throw error
      }
  }
  const handleExceed=()=>{
    if (from.images.length >= 10) {
        ElMessage.error(t('setup583'))
        return false;
      }
  }
  // 封面商品图片上传方法
  const customUpload = async (options) => {
    console.log(from.images)
    if (from.images.length >= 10) {
        ElMessage.error(t('setup583'))
        return false;
      }else{

     
      try {
          // 1. 获取文件扩展名
          const fileExt = options.file.name.split('.').pop()
  
          // 2. 调用后端接口获取预签名URL
          const { data: presignedData } = await setshelvesFilterAPI({
              fileExtension: fileExt,
              bucketName: 'shop-test'
          })
  
          // 3. 准备表单数据
          const formData = new FormData()
          // 添加后端返回的所有表单字段
          Object.entries(presignedData.formData).forEach(([key, value]) => {
              formData.append(key, value)
          })
          console.log(presignedData.formData)
          // 添加文件
          formData.append('file', options.file)
  
          // // 4. 执行上传
          const response = await axios.post(presignedData.url, formData, {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
          })
  
          // // 5. 上传成功
          if (response.status === 204) {
              console.log(response)
              ElMessage.success(t('number20'))
              // 构建文件访问URL
              const fileUrl = `${presignedData.url}${presignedData.formData.key}`
              // 可以在这里处理上传成功后的逻辑，比如将fileUrl保存到表单中
              from.images.push(fileUrl)
              console.log('图片上传成功',from.images)
          }
      } catch (error) {
          ElMessage.error(error.message)
          throw error
      }
    }
  }
  const tabs = ref([
    { name: '简体中文', content: 'zn' },
    { name: 'English', content: 'en_us' },
    { name: '西班牙语', content: 'esp' },
    { name: '葡萄牙语', content: 'pcp' },
    { name: '荷兰语', content: 'ned' },
    { name: '波兰语', content: 'pl' },
    { name: '德语', content: 'de' },
    { name: '法语', content: 'pcf' },
    { name: '意大利语', content: 'ita' },
  ]);
  
  const activeTab = ref(0);
  
  const selectTab = (index) => {
    activeTab.value = index;
  };
  
  //获取商品分类
  const CategoryClass = ref()
  const getCategoryClass = async () => {
      let language=localStorage.getItem('language');
      console.log('语言',language)
      if(language=='zh-cn'){
          language='zn'
      }
      const res = await getTreeCategoryListAPI({iso:language.toLowerCase()})
      if (res.code == 0) {
          CategoryClass.value = res.data.data
      }
  }
  const CurrencyAll=ref()

  
  const activeTopTab = ref('basic');
  // 方法：判断对象是否为空
  const isNotEmptyObject = (obj) => {
    return Object.values(obj).some(value => value !== "" && value !== undefined && value !== null);
  };
  const allowNonChinese=(event)=> {
    // 阻止中文字符输入
    if (/[\u4e00-\u9fa5]/.test(event.key)) {
      event.preventDefault();
    }
  }
/**
 * 设置分类
 * @param value 
 */
// const handleChange = (value) => {
//   console.log('分类',value)
//   from.categoryId = value;
//   console.log('分类1', from.categoryId)
// }
const handleCascaderChange=(value)=> {
        console.log("选中的值（数组）:", value);
        // 如果需要最后一个选中的值
        from.categoryId = value[value.length - 1];
        console.log("最后一级的 ID:", from.categoryId);
}
const handleSelect = (data) => {
    console.log('点击的数据',data)
  // 直接设置选中的值
  from.categoryId = data.id;
//   handleChange(data.id);
};
const contentChangita=(data)=>{
    from.description.ita=data
}
const contentChangde=(data)=>{
    from.description.de=data
}
const contentChangpcf=(data)=>{
    from.description.pcf=data
}
const contentChangen=(data)=>{
    from.description.en_us=data
}
const contentChangzn=(data)=>{
    from.description.zn=data
}
const contentChangesp=(data)=>{
    from.description.esp=data
}
const contentChangpcp=(data)=>{
    from.description.pcp=data
}
const contentChangned=(data)=>{
    from.description.ned=data
}
const contentChangpl=(data)=>{
    from.description.pl=data

}
const changeVariables=(value)=>{
    console.log(value)
    // skusDetailData.value=[]
}

//设置常用
const setCommon=async (item)=>{

    console.log(item)
   if(item.values.length>0) {
        const res=await addTemplateAPI(item);
        if(res.code==0){
            ElMessage({ type: 'success', message: t('setup597') })
            getTemplateList()
            // ElMessage({ type: 'error', message: res.message })
        }else{
            ElMessage({ type: 'error', message: res.message })
        }
   }else{
    ElMessage({ type: 'warning', message: t('setup608') })
   }
    //  
    //获取请求

}
/**
 * 获取模版列表
 */
const TemplateList=ref([]);
const getTemplateList=async ()=>{
    const res = await getTemplateListAPI({page:1,page_size:100})
      if (res.code == 0) {
        if(res.data.list==null){
            TemplateList.value=[]
        }else{
            TemplateList.value = res.data.list
        }
        
        console.log('TemplateList.value',TemplateList.value)
      }
}
const CommonAll=ref(0)
const tooltipRefs = ref([]); 
const activePopoverIndex=ref()
//点击模版
const checkCommon=(item,index)=>{
    console.log(from.multiSkuData)
    let hasCommonTemplateId=false
    if(from.multiSkuData.length>0){
        from.multiSkuData.map(item1=>{
            if(item1.name.zn==item.name.zn){
                hasCommonTemplateId=true
            }
        })
        console.log(hasCommonTemplateId)
    }
   
    CommonAll.value=0
    if(hasCommonTemplateId==true){
        ElMessage({ type: 'error', message: t('setup596') })
    }else{
        item.checked=false
        console.log(index)
        // tooltipRefs.value[index].open()
        activePopoverIndex.value = index;
        console.log(activePopoverIndex.value)
    }
    
}
//判断模版里面的型号
const changePopoveritem=(type,item,items)=>{
  
    if(type==1){//表示全选
        console.log(type,item,items)
        if(item.checked){
            items.forEach(i=>{
                i.check=true
            })
            CommonAll.value=items.length
        }else{
            items.forEach(i=>{
                i.check=false
            })
            CommonAll.value=0
        }
        
    }else{//表示单选
        console.log(type,item,items)
        if(items.check){
            items.check=false
        }else{
            items.check=true
        }
        let num=0
        item.values.forEach(i=>{
            if(i.check==true){
                num++ ;
                console.log(num)
            }
            
        })
        console.log(num)
        if(num==item.values.length){
            item.checked=true
        }else{
            item.checked=false
        }
        CommonAll.value=num
    }

}

// 动态设置 ref
const setTooltipRef = (el, index) => {
  if (el) {
    tooltipRefs.value[index] = el;
  }
};

// 关闭指定 index 的 tooltip
const closeTooltip = (index,item) => {
  if (tooltipRefs.value[index]) {
    // tooltipRefs.value[index].onClose(); // 调用 hide() 方法
    activePopoverIndex.value=null
  }
  nextTick(()=>{
    item.checked=false
    item.values.forEach(i=>{
        i.check=false
    })
 }) 
};
//添加模版在规格里
const addCommon=(item,index)=>{
    if(from.multiSkuData.length==2){
        ElMessage({message: t('setup590'),type: 'warning',})
        return;
    }
    let newValues=item.values
    let value= newValues.filter(i => i.check === true);
    if(value.length==0){
        ElMessage({ type: 'error', message: t('setup595') })
    }else{
        console.log(from.multiSkuData)
        if(from.multiSkuData.length>0){
            let hasCommonTemplateId =false
            from.multiSkuData.map(item1=>{
                if(item1.name.zn==item.name.zn){
                    hasCommonTemplateId=true
                }
            })
           
            if(hasCommonTemplateId==true){
                ElMessage({ type: 'error', message: t('setup596') })
                CommonAll.value=0
            }else{
                item.values =value
                console.log(item)
                from.multiSkuData.push(item)
                if (tooltipRefs.value[index]) {
                    tooltipRefs.value[index].hide(); // 调用 hide() 方法
                }
            }
        }else{
           
            // item.values =value
             let checkitemCommon=item
            checkitemCommon.values=value
            console.log('将选中的值存在checkitemCommon里面',checkitemCommon)
            from.multiSkuData.push(checkitemCommon)
            if (tooltipRefs.value[index]) {
                tooltipRefs.value[index].hide(); // 调用 hide() 方法
            }
        }
        const result = from.multiSkuData.map(item => {
          
            const valueArray = [{ name: item?.name?.zn }]; // 添加属性名称
            item.values.forEach(value => {
                valueArray.push({ name: value.name.zn }); // 添加属性值
            });
            return { value: valueArray };
        });
        console.log(result)
        param.newData=JSON.parse(JSON.stringify(result))
       nextTick(()=>{
        item.checked=false
        item.values.forEach(i=>{
            i.check=false
        })
       }) 
    }
   
    
}
const  languageAll= [
{
    value: 'all',
    label: t('setup620'),
},  
  {
    value: 'en_us',
    label: 'English',
  },
  {
    value: 'esp',
    label: t('setup523'),
  },
  {
    value: 'pcp',
    label: t('setup524'),
  },
  {
    value: 'ned',
    label: t('setup525'),
  },
  {
    value: 'pl',
    label: t('setup526'),
  },
  {
    value: 'de',
    label: t('setup527'),
  },
  {
    value: 'pcf',
    label: t('setup528'),
  },
  {
    value: 'ita',
    label: t('setup529'),
  },
]
const defaultlang=[
    {
        value: 'zn',
        label: t('setup522'),
    }, 
    {
        value: 'en_us',
        label: 'English',
    },
  {
    value: 'esp',
    label: t('setup523'),
  },
  {
    value: 'pcp',
    label: t('setup524'),
  },
  {
    value: 'ned',
    label: t('setup525'),
  },
  {
    value: 'pl',
    label: t('setup526'),
  },
  {
    value: 'de',
    label: t('setup527'),
  },
  {
    value: 'pcf',
    label: t('setup528'),
  },
  {
    value: 'ita',
    label: t('setup529'),
  },
]
const translate=ref()
const translateLanguage=ref()
const translateLoading=ref(false)
const skutranslate=ref()
const skutranslateLanguage=ref()
const skutranslateLoading=ref(false)
/**
 * 翻译
 * type 1表示标题
 * 2表示规格
 */
const interpret=async (type)=>{
       let text=''
       if(type==1){
       
        if((translate.value=='zn') ){
            if(from.name.zn==''){
                ElMessage({ type: 'warning', message: t('setup609') });
                return;
            }else{
                text=from.name.zn
            }
        }else if((translate.value=='en_us') ){
            if(from.name.en_us==''){
                ElMessage({ type: 'warning', message: t('setup610') });
                return;
            }else{
                text=from.name.en_us
            }
        }else if((translate.value=='esp') ){
            if(from.name.esp==''){
                ElMessage({ type: 'warning', message: t('setup611') });
                return;
            }else{
                text=from.name.esp
            }
        }else if((translate.value=='pcp') ){
            if(from.name.pcp==''){
                ElMessage({ type: 'warning', message: t('setup612') });
                return;
            }else{
                text=from.name.pcp
            }
        }else if((translate.value=='ned') ){
            if(from.name.ned==''){
                ElMessage({ type: 'warning', message: t('setup613') });
                return;
            }else{
                text=from.name.ned
            }
        }else if((translate.value=='pl') ){
            if(from.name.pl==''){
                ElMessage({ type: 'warning', message: t('setup614') });
                return;
            }else{
                text=from.name.pl
            }
        }else if((translate.value=='de') ){
            if(from.name.de==''){
                ElMessage({ type: 'warning', message: t('setup615') });
                return;
            }else{
                text=from.name.de
            }
        }else if((translate.value=='pcf') ){
            if(from.name.pcf==''){
                ElMessage({ type: 'warning', message: t('setup616') });
                return;
            }else{
                text=from.name.pcf
            }
        }else if((translate.value=='ita') ){
            if(from.name.ita==''){
                ElMessage({ type: 'warning', message: t('setup617') });
                return;
            }else{
                text=from.name.ita
            }
        }
    }else{
       
        if(skutranslate.value=='zn'){
            if(standardForm.name.zn==''){
                ElMessage({ type: 'warning', message: t('setup609') });
                return;
            }else{
                text=standardForm.name.zn
            }
        }else if(skutranslate.value=='en_us'){
            if(standardForm.name.en_us==''){
                ElMessage({ type: 'warning', message: t('setup610') });
                return;
            }else{
                text=standardForm.name.en_us
            }
        }else if(skutranslate.value=='esp'){
            if(standardForm.name.esp==''){
                ElMessage({ type: 'warning', message: t('setup611') });
                return;
            }else{
                text=standardForm.name.esp
            }
        }else if(skutranslate.value=='pcp'){
            if(standardForm.name.pcp==''){
                ElMessage({ type: 'warning', message: t('setup612') });
                return;
            }else{
                text=standardForm.name.pcp
            }
        }else if(skutranslate.value=='ned'){
            if(standardForm.name.ned==''){
                ElMessage({ type: 'warning', message: t('setup613') });
                return;
            }else{
                text=standardForm.name.ned
            }
        }else if(skutranslate.value=='pl'){
            if(standardForm.name.pl==''){
                ElMessage({ type: 'warning', message: t('setup614') });
                return;
            }else{
                text=standardForm.name.pl
            }
        }else if(skutranslate.value=='de'){
            if(standardForm.name.de==''){
                ElMessage({ type: 'warning', message: t('setup615') });
                return;
            }else{
                text=standardForm.name.de
            }
        }else if(skutranslate.value=='pcf'){
            if(standardForm.name.pcf==''){
                ElMessage({ type: 'warning', message: t('setup616') });
                return;
            }else{
                text=standardForm.name.pcf
            }
        }else if(skutranslate.value=='ita'){
            if(standardForm.name.ita==''){
                ElMessage({ type: 'warning', message: t('setup617') });
                return;
            }else{
                text=standardForm.name.ita
            }
        }
    }
        if(type==1){//表示标题
            translateLoading.value=true
            let data={
                from:translate.value,
                language:translateLanguage.value,
                text:text
            }
            const res=await getProductTranslationAPI(data);
            if(res.code==0){
                console.log(translateLanguage.value)
                translateLoading.value=false
                if(translateLanguage.value=='all'){
                    from.name.de=res.data.de
                    from.name.en_us=res.data.en_us
                    from.name.esp=res.data.esp
                    from.name.ita=res.data.ita
                    from.name.ned=res.data.ned
                    from.name.pcf=res.data.pcf
                    from.name.pcp=res.data.pcp
                    from.name.pl=res.data.pl
                    from.name.zn=res.data.zn
                }else{  
                    from.name[translateLanguage.value] = res.data[translateLanguage.value];
                }
            }
        }else{
            skutranslateLoading.value=true
            let data={
                from:skutranslate.value,
                language:skutranslateLanguage.value,
                text:text
            }
            const res=await getProductTranslationAPI(data);
            if(res.code==0){
                console.log(skutranslateLanguage.value)
                skutranslateLoading.value=false;
                if(skutranslateLanguage.value=='all'){
                    standardForm.name.de=res.data.de
                    standardForm.name.en_us=res.data.en_us
                    standardForm.name.esp=res.data.esp
                    standardForm.name.ita=res.data.ita
                    standardForm.name.ned=res.data.ned
                    standardForm.name.pcf=res.data.pcf
                    standardForm.name.pcp=res.data.pcp
                    standardForm.name.pl=res.data.pl
                    standardForm.name.zn=res.data.zn
                }else{  
                    standardForm.name[skutranslateLanguage.value] = res.data[skutranslateLanguage.value];
                }
            }
        }
    
}
const isMobile=ref(false)
onMounted(async () => {
let all=localStorage.getItem('CurrencyAll')
CurrencyAll.value =JSON.parse(all)
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (router.currentRoute.value.params.id) {
        detail()
    }else{
    updataDetail.value=false
    // isEdit.value=false
    }
    getCategoryClass();
    getTemplateList()
    // 在组件创建时设置第一个选项为默认值
    translateLanguage.value = 'all'
    translate.value = 'zn'
    skutranslate.value='zn'
    skutranslateLanguage.value='all'
})
const childRefzn = ref(null)
const childRefen = ref(null)
const childRefesp = ref(null)
const childRefpcp = ref(null)
const childRefned = ref(null)
const childRefpl = ref(null)
const childRefde = ref(null)
const childRefpcf = ref(null)
const childRefita = ref(null)
	// 三、函数
const getChild = () => {
    // 调用子组件的方法或者变量，通过value
    if (childRefzn.value) {
        childRefzn.value.map(item=>{
            item.Reseteditor("")
        }) 
    }
    if (childRefen.value) {
        childRefen.value.map(item=>{
            item.Reseteditor("")
        }) 
    }
    if (childRefesp.value) {
        childRefesp.value.map(item=>{
            item.Reseteditor("")
        }) 
    }
    if (childRefpcp.value) {
        childRefpcp.value.map(item=>{
            item.Reseteditor("")
        }) 
    }
    if (childRefned.value) {
        childRefned.value.map(item=>{
            item.Reseteditor("")
        }) 
    }
    if (childRefpl.value) {
        childRefpl.value.map(item=>{
            item.Reseteditor("")
        }) 
    }
    if (childRefde.value) {
        childRefde.value.map(item=>{
            item.Reseteditor("")
        }) 
    }
    if (childRefpcf.value) {
        childRefpcf.value.map(item=>{
            item.Reseteditor("")
        }) 
    }
    if (childRefita.value) {
        childRefita.value.map(item=>{
            item.Reseteditor("")
        }) 
    }
}
//重置
const ResetForm=()=>{
    getChild()
    from.description.zn=null;
    getTemplateList()
    from.skuData.price=null;
    from.skuData.quantity=null
    from.skuData.skuId=''
    from.multiSkuData=[]
    //清空批量
    param.newItem.skuId=null;
    param.newItem.price=null;
    param.newItem.quantity=null;
    activePopoverIndex.value=null
    formRef.value.resetFields()
   
}
  </script>
  <template>
      <div class="release" v-if="isMobile==false">
          <div class="title" v-if="router.currentRoute.value.params.id">
              {{$t('setup14')}}
          </div>
          <div class="title" v-else>
              {{$t('setup15')}}
          </div>
          <div class="contents">
              <el-form ref="formRef" :model="from" label-width="auto"  :rules="rules" label-position="right"
                              class="commodityform" :inline-message='true'>
              <div >
                  <div>
                      <ul class="tabs-top">
                          <li  :class="['tab-item', { active: activeTopTab === 'basic' }]" @click="activeTopTab = 'basic'">
                              {{ $t('setup507') }}
                          </li>
                          <li :class="['tab-item', { active: activeTopTab === 'details' }]"  @click="activeTopTab = 'details';activeTab=0">
                            {{ $t('setup49') }}
                          </li>
                      </ul>
                  </div>
                  <div class="tab-content">
                      <div v-show="activeTopTab=='basic'">
                          <div class="Information">
                          
                          <div class="Information-title">
                              {{ $t('setup515') }}
                          </div>
                          <div class="Information-content">
                          <!-- <el-form-item :label="t('setup17')" prop="categoryId" :inline-message='true'>
                              <el-select v-model="from.categoryId" style="width: 600px;" class="select-full-width" :placeholder="t('setup17')">
                                  <el-option v-for="item in CategoryClass" :key="item.id" :label="item.name" :value="item.id">
                                      {{ item.name }}
                                  </el-option>
                              </el-select>
                          </el-form-item> @change="handleChange" -->
                          <el-form-item :label="t('setup17')" prop="categoryId" :inline-message='true'>
                            <el-cascader
                                v-model="from.categoryId"
                                style="width: 600px;"
                                :options="CategoryClass"
                                @change="handleCascaderChange"
                                :props="{
                                    children: 'children',
                                    value: 'id',
                                    label: 'name',
                                    checkStrictly: true,
                                }"
                                filterable
                                clearable
                            >

                                <template #default="{ node, data }">
                                <div @click.stop="handleSelect(data)">
                                    {{ data.name }}
                                </div>
                                </template>
                            </el-cascader>
                        </el-form-item> 
                          <el-form-item :label="t('setup18')" prop="name" >
                              <div>
                                  <el-form-item prop="name.zn" class="custom-form-item bottom-padding" >
                                      <div style="display: inline-block">
                                          <el-input v-model="from.name.zn" :placeholder="t('setup522')" style="width: 600px;"  maxlength="500" show-word-limit>
                                              <template #prepend><div style="width: 100px;">{{ $t('setup522') }}</div></template>
                                          </el-input>
                                      </div>
                                  </el-form-item>
                                  <div class="HorizontalCenter" style="padding: 10px 0;margin-bottom: 10px;background: #f4f6f9;">
                                   {{$t('setup618')}}: 
                                    <el-select
                                    v-model="translate"
                                    style="width: 180px;margin-left: 10px;"
                                    >
                                    <el-option
                                        v-for="item in defaultlang"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    />
                                    </el-select>
                                    <svg-icon icon-class="arrow" style="width: 35px;height: 30px;"/>
                                    <el-select v-model="translateLanguage" placeholder="Select" style="width: 180px"  >
                                        <el-option
                                            v-for="item in languageAll"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        />
                                    </el-select>
                                    <el-button type="danger" plain style="margin-left: 10px;" :loading="translateLoading" @click="interpret(1)">{{$t('setup619')}}</el-button>
                                  </div>
                                  <el-form-item prop="name.en_us" class="custom-form-item bottom-padding">
                                      <div style="display: inline-block">
                                          <el-input v-model="from.name.en_us" placeholder="English" style="width: 600px;" maxlength="500" show-word-limit>
                                          <template #prepend >
                                              <div style="width: 100px;">English</div></template>
                                          </el-input>
                                          </div>
                                  </el-form-item>
                                 
                                  <el-form-item prop="name.esp" class="custom-form-item bottom-padding">
                                      <div style="display: inline-block">
                                          <el-input v-model="from.name.esp" :placeholder="t('setup523')" style="width: 600px;" maxlength="500" show-word-limit>
                                          <template #prepend >
                                              <div style="width: 100px;">{{ $t('setup523') }}</div></template>
                                          </el-input>
                                          </div>
                                  </el-form-item>
                                  <el-form-item prop="name.pcp" class="custom-form-item bottom-padding">
                                      <div style="display: inline-block">
                                          <el-input v-model="from.name.pcp" :placeholder="t('setup524')" style="width: 600px;" maxlength="500" show-word-limit>
                                          <template #prepend >
                                              <div style="width: 100px;">{{$t('setup524')}}</div></template>
                                          </el-input>
                                          </div>
                                  </el-form-item>
                                  <el-form-item prop="name.ned" class="custom-form-item bottom-padding">
                                      <div style="display: inline-block">
                                          <el-input v-model="from.name.ned" :placeholder="t('setup525')" style="width: 600px;" maxlength="500" show-word-limit>
                                          <template #prepend >
                                              <div style="width: 100px;">{{$t('setup525')}}</div></template>
                                          </el-input>
                                          </div>
                                  </el-form-item>
                                  <el-form-item prop="name.pl" class="custom-form-item bottom-padding">
                                      <div style="display: inline-block">
                                          <el-input v-model="from.name.pl" :placeholder="t('setup526')" style="width: 600px;" maxlength="500" show-word-limit>
                                          <template #prepend >
                                              <div style="width: 100px;">{{ $t('setup526') }}</div></template>
                                          </el-input>
                                          </div>
                                  </el-form-item>
                                  <el-form-item prop="name.de" class="custom-form-item bottom-padding">
                                      <div style="display: inline-block">
                                          <el-input v-model="from.name.de" :placeholder="t('setup527')" style="width: 600px;" maxlength="500" show-word-limit>
                                          <template #prepend >
                                              <div style="width: 100px;">{{$t('setup527')}}</div></template>
                                          </el-input>
                                          </div>
                                  </el-form-item>
                                  <el-form-item prop="name.pcf" class="custom-form-item bottom-padding">
                                      <div style="display: inline-block">
                                          <el-input v-model="from.name.pcf" :placeholder="t('setup528')" style="width: 600px;" maxlength="500" show-word-limit>
                                          <template #prepend >
                                              <div style="width: 100px;">{{ $t('setup528') }}</div></template>
                                          </el-input>
                                          </div>
                                  </el-form-item>
                                  <el-form-item prop="name.ita" class="custom-form-item bottom-padding">
                                      <div style="display: inline-block">
                                          <el-input v-model="from.name.ita" :placeholder="t('setup529')" style="width: 600px;" maxlength="500" show-word-limit>
                                          <template #prepend >
                                              <div style="width: 100px;">{{$t('setup529')}}</div></template>
                                          </el-input>
                                          </div>
                                  </el-form-item>
                              </div>
                          </el-form-item>
                        
                          <el-form-item :label="t('setup21')" prop="images">
                            
                            <el-tooltip  placement="top" effect="light">
                                        <template #content> 
                                            <div style="color: red;">* {{ $t('setup582') }}</div>
                                        </template>
                                       <img src="../../assets/images/hint.png" style="position: absolute;
    top: 20px;width: 11px;height: 11px;margin-top: -20px;margin-left: -14px;margin-right: 4px;" alt="" srcset="">
                                   </el-tooltip>
                               <!-- 可拖拽的图片列表 -->
                                <div
                                ref="listRef"
                                class="el-upload-list el-upload-list--picture-card"
                                style="position: relative; min-height: 148px;"
                                >
                                <el-upload v-model:file-list="from.fileList" :http-request="customUpload" :show-file-list="false"
                                :before-upload="beforeUpload" list-type="picture-card" :on-remove="handleRemove" :on-exceed="handleExceed"
                                :on-preview="handlePictureCardPreview" :limit="10" multiple style="width: 148px;height: 148px;position: absolute;z-index: 99;">
                                        <img style="width: 20px;height: 20px;" src="../../assets/images/Upload.PNG" alt="" srcset="">
                                    </el-upload>
                                  
                                <VueDraggable
                                 
                                    ref="el"
                                    v-model="from.images"
                                    :disabled="disabled"
                                    :animation="150"
                                    ghostClass="ghost"
                                    @start="onStart"
                                    @update="onUpdate"
                                    @end="onEnd"
                                    class="Draggable"
                                    style="display: flex;flex-wrap: wrap;"
                                    >
                                   
                                    <div
                                        v-for="file in from.images"
                                        :key="file"
                                        class="el-upload-list__item is-success uploadlist"
                                    >
                                        <img :src="file" class="el-upload-list__item-thumbnail">
                                        <span class="el-upload-list__item-actions">
                                        <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                            <svg-icon icon-class="fangdajin" style="width: 20px;height: 20px;" />
                                        </span>
                                        <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                                            <svg-icon icon-class="imgdel" style="width: 18px;height: 18px;" />
                                        </span>
                                        </span>
                                    </div>
                                    
                                   
                                </VueDraggable>
                              
                                
                            </div>
                               
                              <el-dialog v-model="dialogVisible">
                                    <img w-full :src="dialogImageUrl" alt="Preview Image" />
                                </el-dialog>
                               
                          </el-form-item>
                          <el-form-item :label="t('setup539')" >
                             
                              <el-upload
                                  :http-request="uploadSuccess"
                                 class="upload-demo" :show-file-list="false" :limit="1"
                                  :before-upload="videoBeforeUpload"
                                  accept="video/mp4,video/webm,video/ogg"
                              >
                                  <video controls v-if="from.video" style="width: 148px;
      height: 148px;">
                                  <source :src="from.video" type="video/mp4" >
                                  {{ $t('setup497') }}
                                  </video>
                                 <div v-else class="upload">
                                         <img style="width: 20px;height: 20px;" src="../../assets/images/Upload.PNG" alt="" srcset="">
                                
                                 </div>
                              </el-upload>
                              
                              
                            
                          </el-form-item>
                          <el-form-item :label="t('setup678')">
                            <el-radio-group v-model="from.needIntlPostage">
                                <el-radio :value="false">{{ $t('setup679') }}</el-radio>
                                <el-radio :value="true">{{ $t('setup680') }}</el-radio>
                            </el-radio-group>
                          </el-form-item>
                          </div>
                        
                          <div class="Information-title" style="margin-top: 20px;">
                              {{ $t('setup35') }}
                          </div>   
                          <div class="Information-content">
                          <el-form-item :label="t('setup530')">
                              <el-switch v-model="from.isVariables" @change="changeVariables"/>
                          </el-form-item>
                          <div v-if="from.isVariables==false">
                              <el-form-item label="" prop="skuData">
                              <el-form-item label="sku" prop="skuData.skuId" style="margin-bottom: 16px;">
                                  <el-input  v-model="from.skuData.skuId" maxlength="60" :disabled="from.skuData.isEdit" style="width: 600px;"/>
                              </el-form-item>
                              <el-form-item :label="t('setup531')" prop="skuData.price" style="margin-bottom: 16px;">
                                <el-tooltip  placement="top" effect="light">
                                        <template #content> 
                                            <div v-for="(item,i) in CurrencyAll" :key="i">
                                               <div v-if="item.currency!='CNY'"> 1 CNY ≈ {{(1*item.rate)}} {{ item.currency }}</div>
                                            </div>
                                        </template>
                                       <img src="../../assets/images/hint.png" style="width: 11px;height: 11px;margin-top: -20px;margin-left: -14px;margin-right: 4px;" alt="" srcset="">
                                   </el-tooltip>
                                  <el-input-number v-model="from.skuData.price"  :precision="2" :min="1" style="width: 600px;">
                                  </el-input-number>
                                 
                              </el-form-item>
                              <el-form-item :label="t('cart3')" prop="skuData.quantity" style="margin-bottom: 16px;">
                                  <el-input-number v-model="from.skuData.quantity"  :precision="0" :min="1" style="width:600px">
                                  </el-input-number>
                              </el-form-item>
                          </el-form-item>
                          </div>
                        <div v-else>
                                  <el-form-item label=" ">
                                    
                                    <div class="multiSkuData" v-if=" TemplateList?.length>0">
                                    <div class="containerDiv">
                                        <div class="header">
                                            <div class="headerLeft"><span>{{ $t('setup591') }}</span></div><div class="headerRight"></div>
                                        </div>
                                        <div class="CommonContent">
                                            <div class="CommonItem">
                                                <div v-for="(item,index) in TemplateList" :key="index" class="popover">
                                                    <el-popover  :ref="(el) => setTooltipRef(el, index,item)" :visible="activePopoverIndex === index" placement="bottom-start" :width="630" trigger="click" manual>
                                                        <template #reference>
                                                            <div class="item" @click="checkCommon(item,index)">{{item.name?.zn}}</div>
                                                        </template>
                                                        <template #default>
                                                            <div class="popovertitle">{{ $t('setup592') }}</div>
                                                            <div class="popoverContent" >
                                                                <div  :class="items?.check ? 'checkpopoveritem':'popoveritem'"  v-for="(items,indexs) in item?.values" :key="indexs" @click="changePopoveritem(2,item,items)">
                                                                     {{ items.name?.zn }}
                                                                </div>
                                                            </div>
                                                            <div class="popoverbottom">
                                                                <div>
                                                                    <el-checkbox v-model="item.checked" @change="changePopoveritem(1,item,item?.values)" :label="t('setup472')" size="large" />
                                                                </div>
                                                                <div>
                                                                    <el-button  @click="closeTooltip(index,item)">{{ $t('setup593') }}</el-button>
                                                                    <el-button color="#FC3938" plain @click="addCommon(item,index)">{{$t('setup594')}}({{ CommonAll }})</el-button>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    
                                                    </el-popover>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    </div>
                                      <div class="multiSkuData">
                                          <div class="containerDiv" v-for="(item,index) in from.multiSkuData" :key="index">
                                              <div class="header">
                                                  <div class="headerLeft">
                                                      <span>{{ item.name?.zn}}</span>
                                                      <span class="spanCkick" @click="editSkuData(index)">{{$t('number24')}}</span>
                                                      <span class="spanCkick" style="color: #FC3938;" @click="delskuData(index)">{{ $t('number119') }}</span>
                                                  </div>
                                                  <div class="headerRight">
                                                      <div class="checkboxdiv" style="margin-right: 10px;">
                                                        <el-button  type="danger"  text @click="setCommon(item)">{{ t('setup607') }}</el-button>
                                                      </div>
                                                      <div class="checkbox">
                                                          <el-checkbox v-model="item.isImg"  :label="t('setup532')" border />
                                                      </div>
                                                      <div class="checkboxdiv">
                                                          
                                                          <el-button color="#FC3938" plain @click="standard(2,index)">{{ $t('setup533') }}</el-button>
                                                      </div>
                                                  
                                                  </div>
                                              </div>
                                              <div class="content">
                                                  
                                                  <div v-if="item?.values?.length>0">
                                                      <div class="flex">
                                                          <VueDraggable
                                                          ref="el"
                                                          v-model="item.values"
                                                          :disabled="disabled"
                                                          :animation="150"
                                                          ghostClass="ghost"
                                                          @start="onStart"
                                                          @update="onUpdate"
                                                          @end="onEnd"
                                                          class="Draggable"
                                                          >
                                                          <div
                                                              v-for="(items,indexs) in item?.values"
                                                              :key="indexs"
                                                          class="DraggableItem"
                                                          @dblclick="handleDoubleClick(index,indexs)"
                                                          >
                                                          
                                                              <el-upload class="upload-demo" :show-file-list="false" :limit="1"
                                                                  :http-request="(file) => variablesUpload(file, index,indexs)" :before-upload="beforeUpload" >
                                                                  <div v-if="item.isImg==true">
                                                                      <img v-if="items?.img" :src="items?.img" class="avatar" style="width: 22px;background: #fff; height: 22px;margin-right: 5px;"/>
                                                                      <img v-else src="../../assets/images/img.png"  alt="" srcset="" @click="UploadImg" style="width: 22px;background: #fff; height: 22px;margin-right: 5px;">
                                                                  </div>
                                                              </el-upload>
                                                              {{ items.name?.zn }}
                                                              <span class="delete-icon" @click="delskuSubsetData(index,indexs)">
                                                            
                                                                  <svg-icon icon-class="close" style="width: 20px;height: 25px;"/>
                                                              </span>
                                                          </div>
                                                          </VueDraggable>
                                                          <preview-list :list="item.values" />
                                                      </div>
                                                      <p>{{t('setup534')}}</p>
                                                  </div>
                                                  <div class="contentbut" v-else>
                                                      <div style="display: flex;align-items: center;" @click="standard(2,index)"  text><svg-icon icon-class="add" style="width: 45px;height: 36px;"/>添加规格值</div>
                                                  </div>
                                              </div>
                                          </div> 
                                      </div>
                                  </el-form-item> 
                                  <el-form-item label=" ">
                                      <el-button color="#FC3938" plain @click="standard(1)">{{$t('setup535')}}</el-button>
                                  </el-form-item>
                                          <el-form-item label=" " v-if="allValuesHaveLength">
                                          <div style="display: flex;width: 832px;" >
                                              <span v-for="(attr, index) in param.newData" :key="index">
                                                  <el-select
                                                      v-if="attr?.value?.length > 1"
                                                      v-model="headerFilterParams[`model${index}`]"
                                                  class="right-margin"
                                                      style="width: 132px;"
                                                  >
                                                      <el-option
                                                      v-for="(i, id) in attr.value"
                                                      :label="i?.name"
                                                      :value="i?.name"
                                                      :key="id"
                                                      />
                                                  </el-select>
                                              </span>
                                              <el-input @keypress="allowNonChinese" v-model="param.newItem.skuId" placeholder="sku" :disabled="isEdit" class="right-margin"/>
                                              <el-input type="number" v-model="param.newItem.price" :placeholder="t('setup531')" class="right-margin"/>
                                              <el-input @keypress="allowNonChinese" v-model="param.newItem.quantity" class="right-margin" :placeholder="t('cart3')" type="number" />
                                              <el-button color="#FC3938" @click="setNewItem()">{{t('setup536')}}</el-button>
                                          </div>
                                      </el-form-item>
                                      <el-form-item label=" ">
                                        <div 
                                        v-if="allValuesHaveLength" 
                                        style="display: flex; justify-content: space-between; width: 832px;"
                                        >
                                        <!-- 使用 template 包裹循环，直接过滤 CNY -->
                                        <template v-for="(item, i) in CurrencyAll">
                                            <div v-if="item.currency !== 'CNY'" :key="i">
                                            <span>1 CNY ≈ {{ 1 * item.rate }} {{ item.currency }}</span>
                                            </div>
                                        </template>
                                        </div>
                                    </el-form-item>
                                    <el-form-item label=" " v-if="allValuesHaveLength">
                                        
                                          <table width="832px" style="text-align: left;" border="0" cellspacing="0">
                                              <thead>
                                              <tr>
                                                      <th v-for="(attr, index) in from.multiSkuData" :key="index" v-show="attr?.values?.length>0">
                                                      {{ attr?.name?.zn }}
                                                      </th>
                                                  
                                                  <th v-for="header in param.fixedHeaders" :key="header">{{ header.label }}</th>
                                              </tr>
                                              </thead>
                                              <tbody>
                                                  <!-- {{ from.dataAll }} -->
                                                  <tr v-for="(item, index) in from.dataAll" :key="index">
                                                    <!-- {{ isNotEmptyObject(item) }} -->
                                                    <template v-if="isNotEmptyObject(item)">
                                                        <template v-for="(value, key) in item" >
                                                      <td v-if="key !== 'isEdit'" :key="key">
                                                        <el-form-item :prop="`dataAll.${index}.${key}`"  :rules="getFieldRules(key)">
                                                          <el-input v-if="key === 'skuId' " :disabled="item.isEdit" placeholder="sku" v-model="item.skuId" maxlength="60" style="width: 194px;"/>
                                                          <el-input v-else-if="key === 'price'" type="number" placeholder="价格(CNY)" v-model="item.price" style="width: 194px;"/>
                                                          <el-input v-else-if="key === 'quantity'" type="number"  placeholder="数量" v-model="item.quantity" style="width: 194px;"/>
                                                          <div v-else>
                                                              {{ value }}
                                                          </div>
                                                        </el-form-item>
                                                      </td>
                                                    </template>
                                                  </template>
                                                  </tr> 
                                              </tbody>
                                          </table>
                                              <span style="display: none;">{{ param.tableData }}</span>
                                      </el-form-item>
                          </div>
                     </div>
                      </div>
                      </div>
                      <div v-show="activeTopTab === 'details'">
                          <el-form-item  prop="description" >
                                <div class="tabs-container">
                                    <ul class="tabs">
                                        <li
                                            v-for="(tab, index) in tabs"
                                            :key="index"
                                            :class="['tab',activeTab === index ? 'active':'']"
                                            @click="selectTab(index)"
                                        >
                                            {{ tab.name }}
                                        </li>
                                    </ul>
                                    <div class="tab-content">
                                    <div
                                        v-for="(tab, index) in tabs"
                                        :key="index"
                                        :class="{ 'tab-pane active': activeTab === index }"
                                    >
                                    <el-form-item prop="description" class="custom-form-item" >
                                        <el-form-item prop="description.zn" class="custom-form-item" v-show="tab.content=='zn' && activeTab === index" >
                                        <EditorComponent ref="childRefzn" @contentChangzn="contentChangzn" v-model="from.description.zn" style="height: 600px;width: 100%;"  />
                                        </el-form-item>
                                        <el-form-item prop="description.en_us" class="custom-form-item" v-show="tab.content=='en_us'&& activeTab === index">
                                        <EditorComponent ref="childRefen" @contentChangen="contentChangen" v-model="from.description.en_us" style="height: 600px" />
                                        </el-form-item>
                                        <el-form-item prop="description.esp" class="custom-form-item" v-show="tab.content=='esp'&& activeTab === index">
                                        <EditorComponent ref="childRefesp" @contentChangesp="contentChangesp" v-model="from.description.esp" style="height: 600px" />
                                        </el-form-item>
                                        <el-form-item prop="description.pcp" class="custom-form-item" v-show="tab.content=='pcp'&& activeTab === index">
                                        <EditorComponent ref="childRefpcp" @contentChangpcp="contentChangpcp" v-model="from.description.pcp" style="height: 600px" />
                                        </el-form-item>
                                        <el-form-item prop="description.ned" class="custom-form-item" v-show="tab.content=='ned'&& activeTab === index">
                                        <EditorComponent ref="childRefned" @contentChangned="contentChangned" v-model="from.description.ned" style="height: 600px" />
                                        </el-form-item>
                                        <el-form-item prop="description.pl" class="custom-form-item" v-show="tab.content=='pl'&& activeTab === index">
                                        <EditorComponent ref="childRefpl" @contentChangpl="contentChangpl" v-model="from.description.pl" style="height: 600px" />
                                        </el-form-item>
                                        <el-form-item prop="description.de" class="custom-form-item" v-show="tab.content=='de'&& activeTab === index">
                                        <EditorComponent ref="childRefde" @contentChangde="contentChangde" v-model="from.description.de" style="height: 600px" />
                                        </el-form-item>
                                        <el-form-item prop="description.pcf" class="custom-form-item" v-show="tab.content=='pcf'&& activeTab === index">
                                        <EditorComponent ref="childRefpcf" @contentChangpcf="contentChangpcf" v-model="from.description.pcf" style="height: 600px" />
                                        </el-form-item>
                                        <el-form-item prop="description.ita" class="custom-form-item" v-show="tab.content=='ita'&& activeTab === index">
                                        <EditorComponent ref="childRefita" @contentChangita="contentChangita" v-model="from.description.ita" style="height: 600px" />
                                        </el-form-item> 
                                    </el-form-item>
                                    </div>
                                    </div>
                                </div> 
                            </el-form-item>
                      </div>
                  </div>
              </div>
          </el-form>
              <div class="butSubmit">
                  <div  @click="handleSubmit" class="Submit">{{ $t('cart61') }}</div>
                  <div @click="ResetForm()" class="Reset" >{{ $t('setup22') }}</div>
              </div>
           </div>
      </div>
      <div v-else style="padding-top: 100px;">
          {{ $t('setup537') }}
      </div>
      <el-dialog
      v-model="standardModel"
      :title="t('number24')"
      width="750"
      :before-close="handleClose"
    >
      <el-form ref="standardFormRef" :model="standardForm"  :rules="standardrules" label-width="auto" style="max-width: 600px">
          <el-form-item :label="t('setup538')" prop="name" >
              <div>
                  <el-form-item prop="name.zn" class="custom-form-item bottom-padding" >
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.zn" :placeholder="t('setup522')" style="width: 600px;">
                              <template #prepend><div style="width: 100px;">{{$t('setup522')}}</div></template>
                          </el-input>
                      </div>
                  </el-form-item>
                  <div class="HorizontalCenter" style="padding: 10px 0;margin-bottom: 10px;background: #f4f6f9;">
                    {{ $t('setup618') }}: 
                    <el-select
                    v-model="skutranslate"
                    style="width: 180px;margin-left: 10px;"
                    >
                    <el-option
                        v-for="item in defaultlang"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                    </el-select>
                    <svg-icon icon-class="arrow" style="width: 35px;height: 30px;"/>
                    <el-select v-model="skutranslateLanguage" placeholder="Select" style="width: 180px"  >
                        <el-option
                            v-for="item in languageAll"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                    <el-button type="danger" plain style="margin-left: 10px;" :loading="skutranslateLoading" @click="interpret(2)">{{ $t('setup619') }}</el-button>
                    </div>
                  <el-form-item prop="name.en_us" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.en_us" placeholder="English" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">English</div></template>
                          </el-input>
                      </div>
                  </el-form-item>
                  <el-form-item prop="name.esp" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.esp" :placeholder="t('setup523')" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">{{t('setup523')}}</div></template>
                          </el-input>
                      </div>
                  </el-form-item>
                  <el-form-item prop="name.pcp" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.pcp" :placeholder="t('setup524')" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">{{$t('setup524')}}</div></template>
                          </el-input>
                          </div>
                  </el-form-item>
                  <el-form-item prop="name.ned" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.ned" :placeholder="t('setup525')" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">{{$t('setup525')}}</div></template>
                          </el-input>
                          </div>
                  </el-form-item>
                  <el-form-item prop="name.pl" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.pl" :placeholder="t('setup526')" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">{{$t('setup526')}}</div></template>
                          </el-input>
                          </div>
                  </el-form-item>
                  <el-form-item prop="name.de" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.de" :placeholder="t('setup527')" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">{{$t('setup527')}}</div></template>
                          </el-input>
                          </div>
                  </el-form-item>
                  <el-form-item prop="name.pcf" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.pcf" :placeholder="t('setup528')" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">{{$t('setup528')}}</div></template>
                          </el-input>
                          </div>
                  </el-form-item>
                  <el-form-item prop="name.ita" class="custom-form-item bottom-padding">
                      <div style="display: inline-block">
                          <el-input v-model="standardForm.name.ita" :placeholder="t('setup529')" style="width: 600px;">
                          <template #prepend >
                              <div style="width: 100px;">{{ $t('setup529') }}</div></template>
                          </el-input>
                          </div>
                  </el-form-item>
              </div>
          </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="handleClose">Cancel</el-button>
          <el-button type="primary" @click="standardSubmit">
            Confirm
          </el-button>
        </div>
      </template>
    </el-dialog>
  </template>
  
  <style scoped lang="scss">
  :deep(.el-upload--picture-card){
    margin: 0 8px 8px 0;
  }
  :deep(.el-form-item__error){
    z-index: 999999;
  }
  :deep(.el-form-item .el-form-item){
    width: 100%;
  }
  .uploadlist:first-child{
    margin-left: 158px; 
  }
  .popovertitle{
    padding: 10px;

  }
  .popoverContent{
    display: flex;
    flex-wrap: wrap;
        .popoveritem{
        padding: 4px 10px;
        border: 1px solid #dfe6ec;
        margin: 10px;
        display: flex;
        justify-content: center;
        align-items: center;  
        }
        .checkpopoveritem{
            padding: 4px 10px;
            border: 1px solid #FC3938;
            background-color: #fce9e8;
            margin: 10px;
            display: flex;
            justify-content: center;
            align-items: center;  
        }
}
.popoverbottom{
    margin: 20px 5px 5px 5px;
    border: 1px solid #ebebeb;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
  .butSubmit{
      display: flex;
      justify-content: center;
      .Submit{
          width: 200px;
          height: 46px;
          background: #FC3938;
          border-radius: 23px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 21px;
          text-align: left;
          font-style: normal;
          text-transform: uppercase;
      }
      .Reset{
          margin-left: 20px;
          width: 200px;
          height: 46px;
          background: #FFFFFF;
          border-radius: 23px;
          border: 1px solid #FC3938;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 16px;
          color: #FC3938;
          line-height: 21px;
          text-align: left;
          font-style: normal;
          text-transform: uppercase;
      }
  }
  .pc {
      display: block;
  }
  
  .phone {
      display: none;
  }
  .currercy{
      display: flex;
      justify-content: space-between;
      padding-bottom: 10px;
  }
  .bottom-padding{
      margin-bottom: 10px;
      
  } 
  .right-margin{
      margin-right: 10px;
  }
  .release {
      width: 1200px;
      margin: 0 auto;
      position: relative;
      background: #fff;
      // height: 100%;
      margin-top: 30px;
      margin-bottom: 30px;
     
      border-radius: 20px;
  
      .title {
          padding-left: 20px;
          // border-bottom: 1px solid #f5f5f5;
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 18px;
          color: #11192D;
          line-height: 18px;
          text-align: left;
          font-style: normal;
          padding-bottom: 30px;
      }
  
      .contents {
          width: 100%;
          // display: flex;
          // justify-content: center;
          // padding: 20px 20px;
          // border: 1px solid;
          .tabs-top {
          //   border-bottom: 2px solid yellow;
          width: 100%;
          }
  
          .tabs-top {
          display: flex;
          list-style: none;
          padding: 0;
          margin: 0;
          border-bottom: 1px solid #e9ecef;
          width: 100%;
          font-size: 13px;
          }
  
          .tab-item {
              // padding: 3px 16px;
              cursor: pointer;
              background-color: #fff;
              border-bottom: none;
              transition: background-color 0.3s, color 0.3s;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 16px;
              color: #888888;
              line-height: 18px;
              text-align: left;
              font-style: normal;
              // padding-right: 40px;
              padding: 0 20px 10px 20px;
              position: relative; /* 相对定位 */
          }
  
          .active{
              color: #11192D;
          }
          .tab-item.active::after {
              content: '';
              position: absolute;
              left: 40%;
              color: #11192D;
              right: 0;
              bottom: -2px;
              width: 20px;
  height: 4px;
  background: #FC3938;
  border-radius: 2px;
              transition: background-color 0.3s; /* 背景色过渡效果 */
          }
  
          .tab-content {
              padding-top: 10px;
          //   padding: 20px;
          }
  
          .tab-pane {
          display: none;
          }
  
          .tab-pane.active {
          display: block;
          }
          .Information{
              // background-color:  #fbfbfb;
              border: 1px solid #fff;
              border-radius: 5px;
              padding: 19px;
              .Information-title{
                  // padding-bottom: 16px;
                  // border-bottom: 1px solid #e8e8e8;
                  // font-size: 13px;
                  // margin-bottom: 24px;
                  height: 40px;
                  background: #F3F6F8;
                  border-radius: 8px 8px 0px 0px;
                  font-family: MicrosoftYaHei;
                  font-size: 14px;
                  color: #11192D;
                  line-height: 19px;
                  padding-left: 24px;
                  text-align: left;
                  font-style: normal;
                  display: flex;
                  align-items: center;
              }
              .Information-content{
                  padding: 30px 0 0 34px;
                  background: #FFFFFF;
                  border-radius: 0px 0px 8px 8px;
                  border: 1px solid #E5E8EC;
                  border-top: 0; /* 取消上边框 */
                 
                  .upload{
                      width: 148px;
                      height: 148px;border: 1px dashed var(--el-border-color-darker);
                      border-radius: 6px;    display: flex;
                      align-items: center;
                      justify-content: center;background: #F3F6F8;
                      &:hover{
                          border: 1px dashed #FC3938;; 
                      }
                  }
              }
          }
  
          .commodityform {
              width: 100%;
          }
  
  
      }
  }
  .multiSkuData{
      width: 100%;
      .containerDiv {
          margin-top: 10px;
      width: 832px;
      // padding: 20px;
      border: 1px solid  #dfe6ec;
      }
  
      .header {
          display: flex;
          padding: 8px 10px;
          justify-content: space-between;
          // margin-bottom: 20px;s
          background: #F3F6F8;
          // border: 1px solid #E5E8EC;
          align-items: center;
          .headerLeft{
              span {
              margin-right: 10px;
             
              }
              .spanCkick{
                  color: #468ffb;
              }
          }
          .headerRight{
              display: flex;
            
              .checkbox{
              //    border: 1px solid #d9dce3;
              //    padding: 0px 15px;
              //    border-radius: 4px;
              //    margin-top: 10px;
             
              }
              .checkboxdiv{
                  margin-top: -10px;
                  margin-left: 10px;
                  // padding: 0 5px;
                  // border: 1px solid #d9dce3;
                  // display: flex;
                  // align-items: center;
                  // border-radius: 4px;
                  // color: #606266;
                  // font-size: 14px;
                  // font-weight:500
              }
          }
      }
      
     .CommonContent{
        padding: 10px;
        .CommonItem{
            display: flex;
            flex-wrap: wrap;
            .popover{
                .item{
                    padding: 4px 10px;
                    border: 1px solid #dfe6ec;
                    margin: 10px;
                    display: flex;
                    justify-content: center;
                    align-items: center;  
                }
                
            }
           
            
           
           
        }
     }
  
      .content {
          .Draggable{
              display: flex;
              flex-wrap: wrap;
              .DraggableItem{
                  padding: 4px 10px;
                  border: 1px solid #dfe6ec;
                  margin: 10px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  position: relative;
                  cursor: pointer;
                  .delete-icon {
                      position: absolute;
                      top: 4%;
                      right: -8px;
                      transform: translateY(-50%);
                      opacity: 0;
                      transition: opacity 0.3s;
                      cursor: pointer;
                  }
                  &:hover .delete-icon{
                      opacity: 1;
  
                  }
              }
          }
          
          .contentbut{
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 20px;
          }
      }
      
  
     
  
      button {
      margin-top: 10px;
      }
  }
  table {
      border-collapse: separate;
      border-top: 1px solid #dfe6ec;
      border-left: 1px solid #dfe6ec;
  }
  thead tr th {
      background: #F3F6F8;
      padding: 6px;
      text-align: center;
      border-bottom: 1px solid #dfe6ec;
      border-right: 1px solid #dfe6ec;
  }
  tbody tr td {
      background-color: #fff;
      padding: 6px;
      text-align: center;
      height: 34px;//设置单元格最小高度
      border-bottom: 1px solid #dfe6ec;
      border-right: 1px solid #dfe6ec;
  }
  .tabs-container {
  //   border-bottom: 2px solid yellow;
  width: 100%;
  }
  
  .tabs {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    border-bottom: 1px solid #e9ecef;
    width: 100%;
    font-size: 13px;
  }
  
  .tab {
    padding: 3px 16px;
    cursor: pointer;
    background-color: #fff;
    border-bottom: none;
    transition: background-color 0.3s, color 0.3s;
  }
  
  .tab.active {
    background-color: #f8fafd;
    border-right: 1px solid #e9ecef;
    border-left: 1px solid #e9ecef;
    border-top: 1px solid #e9ecef;
    margin-bottom: 1px;
    color: #222;
  
  //   border-bottom-right-radius: 5px;
  }
  
  .tab-content {
      padding-top: 10px;
  //   padding: 20px;
  }
  
  .tab-pane {
    display: none;
  }
  
  .tab-pane.active {
    display: block;
  }
  
  @media (max-width: 768px) {
      .pc {
          display: none !important;
      }
  
      .phone {
          display: block;
      }
      .currercy{
      display: flex;
      justify-content: space-between;
      padding-bottom: 10px;
  
          font-size: 12px;
      }
  
      .release {
          width: 100%;
          padding-top: 45px;
          margin-top: 0px;
          border-radius: 0px;
          height: 100%;
          .title {
              font-size: 15px;
              padding: 10px;
          }
  
          .contents {
              width: 100%;
              display: flex;
              justify-content: center;
              padding: 15px 10px;
              background-color: #fff;
              .imglist {
                  width: 110px;
              }
          }
  
          .but {
              margin-bottom: 70px;
          }
      }
  
      .el-form-item {
          margin-bottom: 15px;
      }
  
      .el-form--default.el-form--label-top .el-form-item .el-form-item__label {
          margin-bottom: 0px;
      }
  }
  </style>